import React from 'react';
import { CheckIcon, FlameIcon, GiftIcon, ShieldCheckIcon, VideoIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME, tomos } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="bg-brand-deep" data-id="element-119" data-mp="dfybgeusx0qo">
      <div className="mx-auto max-w-letter px-4 py-7 text-center sm:px-6 sm:py-8" data-id="element-120" data-mp="metjlwheokwm">
        <p className="text-[0.68rem] font-extrabold uppercase tracking-[0.14em] text-alert" data-id="element-121" data-mp="mgo6hgc8mn3c">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1.5 font-display text-xl uppercase leading-[1.1] tracking-tight text-white sm:text-3xl" data-id="element-122" data-mp="wboi4fdoilaw">
          Comenzá hoy desde cero y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-gold bg-white p-4 sm:p-5" data-id="element-123" data-mp="2y6gr7c7s8htl">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block overflow-hidden rounded-lg transition-transform duration-200 ease-soft hover:scale-[1.01]" data-id="element-124" data-mp="12otf1flef9hy">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="mx-auto w-full max-w-sm" data-id="element-125" data-mp="owdkz4ah6lt6" />
          </a>

          <p className="mt-3 flex items-center justify-center gap-1.5 text-[0.8rem] font-extrabold uppercase leading-tight tracking-tight text-brand sm:text-base" data-id="element-126" data-mp="1lll4y7vg4muz">
            <VideoIcon size={16} className="flex-shrink-0" aria-hidden="true" data-id="element-127" data-mp="1ckn0xpl0cfce" />
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-base uppercase text-brand-dark sm:text-lg" data-id="element-128" data-mp="17m3bhf77glfa">
            6 Tomos + 5 Bonos
          </p>

          <ul className="mx-auto mt-2.5 grid max-w-md gap-1 text-left" data-id="element-129" data-mp="3scu25ywr0xqr">
            {tomos.map((tomo, i) => <li key={tomo.title} className="flex items-start gap-1.5 text-[0.72rem] font-semibold leading-snug text-ink-muted sm:text-[0.8rem]" data-id="element-130" data-mp="3tu99j850tdia" data-mpi={i}>
                <CheckIcon size={13} strokeWidth={3.5} className="mt-0.5 flex-shrink-0 text-brand" aria-hidden="true" data-id="element-131" data-mp="3ktl431tp0lh0" />
                <span data-id="element-132" data-mp="3b2zy2tboweo2">
                  <span className="font-extrabold text-brand-dark" data-id="element-133" data-mp="3b2goq103uyln">
                    Tomo {i + 1}:
                  </span>{' '}
                  {tomo.title}
                </span>
              </li>)}
          </ul>

          <p className="mt-2.5 inline-flex items-center gap-1.5 rounded-md bg-gold px-3 py-1.5 text-[0.72rem] font-extrabold uppercase tracking-tight text-brand-deep sm:text-sm" data-id="element-134" data-mp="31391mm3kjplc">
            <GiftIcon size={14} aria-hidden="true" data-id="element-135" data-mp="2s55skp9rslaf" />
            Bonos valorados en {BONUS_TOTAL}
          </p>

          <p className="mt-2.5 inline-flex items-center gap-1.5 rounded-md bg-alert px-3 py-1 text-[0.68rem] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-136" data-mp="2x2xhdaf4brae">
            <FlameIcon size={13} aria-hidden="true" data-id="element-137" data-mp="28jvt8p46hqg4" />
            Oferta especial
          </p>

          <p className="mt-2 text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-ink-muted" data-id="element-138" data-mp="2mivfxr84rv9n">
            Hoy:
          </p>
          <p className="font-display text-5xl leading-none text-alert sm:text-6xl" data-id="element-139" data-mp="2ifqfdu7m23nn">
            {PRICE}
          </p>
          <p className="mt-1.5 text-[0.72rem] font-semibold text-ink-muted sm:text-sm" data-id="element-140" data-mp="2wegdnd6629dl">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-141" data-mp="365b28o6vxl27">
            Sí, quiero el sistema completo por {PRICE}
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.7rem] font-semibold text-ink-muted sm:text-xs" data-id="element-142" data-mp="3f712mjiqvuc4">
            <span className="flex items-center gap-1.5" data-id="element-143" data-mp="3a9iuuwggrl5p">
              <ZapIcon size={13} className="text-brand" aria-hidden="true" data-id="element-144" data-mp="18ja3pjluxqio" />
              Acceso Inmediato
            </span>
            <span aria-hidden="true" data-id="element-145" data-mp="1dh3cmkejoymn">•</span>
            <span className="flex items-center gap-1.5" data-id="element-146" data-mp="1dfs7oh9d5kty">
              <ShieldCheckIcon size={13} className="text-brand" aria-hidden="true" data-id="element-147" data-mp="1i9wjbdtkqh1d" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}